import { v4 as uuid } from 'uuid';
import type { OnSearchCallback } from './types.tsx';

function createNonReactiveStore() {
	const state: {
		jqlBuilderOnSearch: OnSearchCallback;
		singleInstrumentationID: string;
	} = {
		jqlBuilderOnSearch: () => ({}),
		singleInstrumentationID: '',
	};

	function getJqlBuilderOnSearch() {
		return state.jqlBuilderOnSearch;
	}

	function setJqlBuilderOnSearch(onSearch: OnSearchCallback) {
		state.jqlBuilderOnSearch = onSearch;
	}

	function renewSingleInstrumentationId() {
		state.singleInstrumentationID = uuid();
	}

	function getSingleInstrumentationId() {
		if (state.singleInstrumentationID === '') {
			renewSingleInstrumentationId();
		}
		return state.singleInstrumentationID;
	}

	return {
		getJqlBuilderOnSearch,
		setJqlBuilderOnSearch,
		getSingleInstrumentationId,
		renewSingleInstrumentationId,
	};
}

export const nonReactiveSingleton = (() => {
	let instance: ReturnType<typeof createNonReactiveStore> | null = null;
	return () => {
		if (!instance) {
			instance = createNonReactiveStore();
		}
		return instance;
	};
})();
